export const dedicatedPortfoliosLabels = {
  samplePortfolio: 'Sample portfolio',
  requestHistory: 'Request history',
};
